import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {Support} from "../../../shared/interface/support";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {ActivatedRoute} from "@angular/router";
import {SupportService} from "../../../shared/services/support.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {HttpErrorResponse} from "@angular/common/http";
import {takeUntil} from "rxjs/operators";
import {TerminalsService} from "../../../shared/services/terminals.service";
import {Terminals} from "../../../shared/interface/terminals";

@Component({
  selector: 'app-terminals-details',
  templateUrl: './terminals-details.component.html',
  styleUrls: ['./terminals-details.component.scss']
})
export class TerminalsDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  terminalsId: string;
  terminalsObject?: Terminals;
  terminals: ReplaySubject<Terminals> = new ReplaySubject<Terminals>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;
  constructor( private route: ActivatedRoute,
               private terminalsService: TerminalsService,
               private snack: MatSnackBar,
               private dialog: MatDialog,
               private auth: AuthService,
  )
  {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.terminalsId = params.id;
        this.loadSupport();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadSupport(): void {
    this.terminalsService.get(this.terminalsId).subscribe((terminal: Terminals) => {
      this.terminals.next(terminal);
      this.terminalsObject = terminal;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
